import eventReport from "./event-report.json";

export const eventReports = {
	...eventReport,
};
